import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { CouponGroup } from './couponGroup.types';

export const useCouponGroups = () => {
  return useQuery<AxiosResponse<CouponGroup[], any>>('coupon-groups', () => apiClient.get<CouponGroup[]>('/coupon-groups'));
};
